import { EmptyEdgePropsSchema } from '../../graph-schemas/edges/common';
import type { EdgeDefinition } from './base-crm';

export const PEVC_IR_EDGES: Record<string, EdgeDefinition> = {
  COMMITMENT_FROM: {
    type: 'COMMITMENT_FROM',
    schema: EmptyEdgePropsSchema,
    displayName: 'Commitment From',
    reverseDisplayName: 'Has Commitment',
    sourceTypes: ['Commitment'],
    targetTypes: ['InvestmentAccount'],
    props: [],
  },
  COMMITMENT_TO: {
    type: 'COMMITMENT_TO',
    schema: EmptyEdgePropsSchema,
    displayName: 'Commitment To',
    reverseDisplayName: 'Has Commitment',
    sourceTypes: ['Commitment'],
    targetTypes: ['Vehicle'],
    props: [],
  },
  ACCOUNT_FOR: {
    type: 'ACCOUNT_FOR',
    schema: EmptyEdgePropsSchema,
    displayName: 'Account For',
    reverseDisplayName: 'Has Account',
    sourceTypes: ['InvestmentAccount'],
    targetTypes: ['Organization'],
    props: [],
  },
  CALL_FOR: {
    type: 'CALL_FOR',
    schema: EmptyEdgePropsSchema,
    displayName: 'Call For',
    reverseDisplayName: 'Has Call',
    sourceTypes: ['CapitalCall'],
    targetTypes: ['Commitment'],
    props: [],
  },
  CALL_FROM: {
    type: 'CALL_FROM',
    schema: EmptyEdgePropsSchema,
    displayName: 'Call From',
    reverseDisplayName: 'Issued Call',
    sourceTypes: ['CapitalCall'],
    targetTypes: ['Vehicle'],
    props: [],
  },
  DISTRIBUTION_FOR: {
    type: 'DISTRIBUTION_FOR',
    schema: EmptyEdgePropsSchema,
    displayName: 'Distribution For',
    reverseDisplayName: 'Has Distribution',
    sourceTypes: ['Distribution'],
    targetTypes: ['Commitment'],
    props: [],
  },
  DISTRIBUTION_FROM: {
    type: 'DISTRIBUTION_FROM',
    schema: EmptyEdgePropsSchema,
    displayName: 'Distribution From',
    reverseDisplayName: 'Issued Distribution',
    sourceTypes: ['Distribution'],
    targetTypes: ['Vehicle'],
    props: [],
  },
  REPORT_FOR: {
    type: 'REPORT_FOR',
    schema: EmptyEdgePropsSchema,
    displayName: 'Report For',
    reverseDisplayName: 'Has Report',
    sourceTypes: ['Report'],
    targetTypes: ['Vehicle'],
    props: [],
  },
  SENT_TO: {
    type: 'SENT_TO',
    schema: EmptyEdgePropsSchema,
    displayName: 'Sent To',
    reverseDisplayName: 'Received',
    sourceTypes: ['Report'],
    targetTypes: ['Commitment'],
    props: [],
  },
  ORIGINATED_FROM_OPPORTUNITY: {
    type: 'ORIGINATED_FROM_OPPORTUNITY',
    schema: EmptyEdgePropsSchema,
    displayName: 'Originated From',
    reverseDisplayName: 'Led To',
    sourceTypes: ['InvestmentAccount', 'Commitment'],
    targetTypes: ['FundraisingOpportunity'],
    props: [{ key: 'conversion_date', label: 'Conversion Date', type: 'date' }],
  },
  SIGNATORY_FOR: {
    type: 'SIGNATORY_FOR',
    schema: EmptyEdgePropsSchema,
    displayName: 'Signatory For',
    reverseDisplayName: 'Has Signatory',
    sourceTypes: ['Person'],
    targetTypes: ['InvestmentAccount'],
    props: [
      { key: 'role', label: 'Role', type: 'select', options: ['primary', 'secondary', 'authorized_signer'] },
      { key: 'start_date', label: 'Start Date', type: 'date' },
    ],
  },
  MANAGES_COMMITMENT: {
    type: 'MANAGES_COMMITMENT',
    schema: EmptyEdgePropsSchema,
    displayName: 'Manages Commitment',
    reverseDisplayName: 'Managed By',
    sourceTypes: ['Person'],
    targetTypes: ['Commitment'],
    props: [
      { key: 'role', label: 'Role', type: 'select', options: ['primary_contact', 'secondary_contact', 'authorized_signer'] },
      { key: 'start_date', label: 'Start Date', type: 'date' },
    ],
  },
};
